import React from "react";
import { Button } from "@/components/ui/button";
import { HardHat, ShieldCheck, TrendingUp, Users } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      {/* Left panel */}
      <div className="hidden lg:flex flex-col justify-between p-10 bg-primary text-primary-foreground relative overflow-hidden">
        <div className="relative z-10">
          <div className="flex items-center gap-2 mb-14">
            <div className="h-9 w-9 rounded-md bg-secondary flex items-center justify-center">
              <HardHat className="h-5 w-5 text-primary" />
            </div>
            <div>
              <div className="text-sm text-primary-foreground/70 leading-none">Artisan Guild</div>
              <div className="font-display text-lg font-bold leading-tight">Infra ERP</div>
            </div>
          </div>
          <h1 className="font-display text-4xl xl:text-5xl font-extrabold tracking-tight leading-[1.05] max-w-lg">
            Run every rupee, every day, every site — from one console.
          </h1>
          <p className="mt-6 max-w-md text-primary-foreground/70 text-[15px] leading-relaxed">
            Finance, payroll, subcontractor bills, CRM and MIS — built for
            Indian infrastructure companies with GST, TDS, PF & ESI already handled.
          </p>

          <div className="mt-14 grid grid-cols-2 gap-6 max-w-md">
            <Feature icon={TrendingUp} label="Earned Value Mgmt" desc="PV / EV / AC · CPI · SPI" />
            <Feature icon={Users} label="Payroll ready" desc="PF, ESI, TDS auto-computed" />
            <Feature icon={ShieldCheck} label="Site financials" desc="Labor + subcontractor bills" />
            <Feature icon={HardHat} label="CRM + MIS" desc="Pipeline & billing follow-up" />
          </div>
        </div>
        <div className="relative z-10 text-xs text-primary-foreground/50 font-mono">
          © {new Date().getFullYear()} Artisan Guild Infra
        </div>
        {/* subtle grid overlay */}
        <div className="absolute inset-0 opacity-[0.06] grid-lines pointer-events-none" />
      </div>

      {/* Right panel */}
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex items-center gap-2 mb-8">
            <div className="h-8 w-8 rounded-md bg-primary flex items-center justify-center">
              <HardHat className="h-4 w-4 text-primary-foreground" />
            </div>
            <div className="font-display font-bold">Artisan Guild Infra</div>
          </div>
          <div className="uppercase text-[11px] tracking-widest text-muted-foreground font-mono mb-3">
            Sign in
          </div>
          <h2 className="font-display text-3xl font-bold tracking-tight">
            Welcome to your command centre
          </h2>
          <p className="text-muted-foreground text-sm mt-3">
            Continue with your Google account. Access is provisioned by role: Admin,
            Accountant, HR, Project Manager or Sales.
          </p>

          <Button
            data-testid="google-login-btn"
            onClick={handleLogin}
            className="mt-8 w-full h-11 bg-primary hover:bg-primary/90 text-primary-foreground font-medium"
          >
            <GoogleG className="mr-2 h-4 w-4" />
            Continue with Google
          </Button>

          <div className="mt-10 p-4 border rounded-md bg-card">
            <div className="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2 font-mono">
              Pre-provisioned owner
            </div>
            <div className="text-sm font-medium">agiprojects24@gmail.com</div>
            <div className="text-xs text-muted-foreground mt-1">Role: admin</div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Feature({ icon: Icon, label, desc }) {
  return (
    <div>
      <Icon className="h-5 w-5 text-secondary mb-2" />
      <div className="font-medium text-sm">{label}</div>
      <div className="text-xs text-primary-foreground/60">{desc}</div>
    </div>
  );
}

function GoogleG(props) {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" {...props}>
      <path fill="#EA4335" d="M12 10.2v3.9h5.5c-.2 1.4-1.7 4-5.5 4-3.3 0-6-2.7-6-6.1s2.7-6.1 6-6.1c1.9 0 3.1.8 3.8 1.5l2.6-2.5C16.9 3.4 14.7 2.5 12 2.5 6.9 2.5 2.7 6.7 2.7 12S6.9 21.5 12 21.5c6.9 0 9.4-4.8 9.4-7.3 0-.5 0-.9-.1-1.2H12z"/>
    </svg>
  );
}
